import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { filterUserList } from "../../PresentersActions";
import stylesPc from "./PresentersIndex.module.css";
import stylesSp from "./PresentersIndex_SP.module.css";
import PresentersFilters from "./PresentersFilters";
import { resetUserfilter } from "../../UserFilterActions";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import PresentersProfiles from "./PresentersProfiles";
import { CircularProgress, createStyles, Fab, makeStyles, Slide } from "@material-ui/core";
import { GetRecommendProfessionalList } from "../../../common/homePage/HomePageActions";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useInitFlag } from "../../../components/function/useInitFlag";

interface CheckObject {
    [key: string]: boolean;
}

const useStyles = makeStyles(() =>
    createStyles({
        closeButton: {
            position: "fixed",
            bottom: "16px",
            right: "16px",
            zIndex: 200,
            backgroundColor: "var(--main)",
            color: "var(--white)",
            "&:hover": {
                backgroundColor: "var(--main)",
            },
        },
    })
);

function PresentersIndex() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const dispatch = useDispatch();
    const classes = useStyles();

    const [checkedSkills, setCheckedSkills] = useState<CheckObject>({});
    const [checkedTags, setCheckedTags] = useState<CheckObject>({});

    const { users, isLoading } = useSelector((state: AppState) => ({
        users: state.presenters.index.filteredUsers,
        isLoading: state.presenters.index.isLoading,
    }));

    const { recommendProfessionalList } = useSelector(
        ({ recommendList }: AppState) => recommendList
    );

    const { header } = useSelector((state: AppState) => ({
        header: state.header,
    }));
    const direction = header.direction === "left" ? -1 : header.direction === "same" ? 0 : 1;

    const [msg, setMsg] = useState("");
    const [professionalName, setProfessionalName] = useState("");
    const [isInit, setIsinit] = useState<boolean>(true);
    // データ取得中フラグ
    const [isLoadingData, setIsLoadingData] = useInitFlag(true);

    //filter
    const [openFilter, setOpenFilter] = useState(false);

    const openMsg = (event: React.MouseEvent, flg: boolean, name: string) => {
        if (flg) {
            setMsg("del");
        } else {
            setMsg("add");
        }

        setProfessionalName(name);
    };

    const closeMsg = () => {
        setMsg("");
    };

    const { userFilter, userInfo } = useSelector((state: AppState) => ({
        userFilter: state.userFilter.UserFilters,
        userInfo: state.user.userInfo,
    }));

    useEffect(() => {
        if (userInfo)
            dispatch(
                filterUserList({
                    id: parseInt(userInfo.id),
                    tag: userFilter.tag,
                    skill: userFilter.skill,
                })
            );

        for (const item of userFilter.skill) {
            if (!checkedSkills[item]) {
                setCheckedSkills({
                    ...checkedSkills,
                    [item]: true,
                });
            }
        }

        for (const item of userFilter.tag) {
            if (!checkedTags[item]) {
                setCheckedTags({
                    ...checkedTags,
                    [item]: true,
                });
            }
        }
    }, [dispatch, userFilter, checkedSkills, checkedTags, userInfo]);
    // 取得中フラグ設定
    useEffect(() => {
        setIsLoadingData(true);
        // eslint-disable-next-line
    }, []);

    // 取得完了設定
    useEffect(() => {
        if (!isLoading && isLoadingData && !isInit) {
            setIsLoadingData(false);
        }
        // eslint-disable-next-line
    }, [isLoading]);

    useEffect(() => {
        if (isInit && userInfo) {
            dispatch(GetRecommendProfessionalList(parseInt(userInfo.id)));
            setIsinit(false);
        }
        // eslint-disable-next-line
    }, [dispatch, recommendProfessionalList, isInit, userInfo]);

    const changeSkillFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedSkills({
            ...checkedSkills,
            [event.target.name]: event.target.checked,
        });

        if (!userFilter.skill.includes(Number(event.target.id)) && event.target.checked) {
            userFilter.skill.push(Number(event.target.id));
        }

        if (userFilter.skill.includes(Number(event.target.id)) && !event.target.checked) {
            userFilter.skill = userFilter.skill.filter((t) => t !== Number(event.target.id));
        }

        dispatch(resetUserfilter(userFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
        setOpenFilter(!openFilter);
        window.scrollTo(0, 0);
    };

    const changeTagFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedTags({
            ...checkedTags,
            [event.target.name]: event.target.checked,
        });

        if (!userFilter.tag.includes(Number(event.target.id)) && event.target.checked) {
            userFilter.tag.push(Number(event.target.id));
        }

        if (userFilter.tag.includes(Number(event.target.id)) && !event.target.checked) {
            userFilter.tag = userFilter.tag.filter((t) => t !== Number(event.target.id));
        }

        dispatch(resetUserfilter(userFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
        setOpenFilter(!openFilter);
        window.scrollTo(0, 0);
    };

    if (isLoading || isLoadingData) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    const style = users ? styles.index : styles.noContent;

    const contents = (
        <div className={styles.filterContainer}>
            <PresentersFilters
                anime={direction === 0 ? true : false}
                checkedSkills={checkedSkills}
                checkedTags={checkedTags}
                changeSkillFilter={changeSkillFilter}
                changeTagFilter={changeTagFilter}
            />

            <PresentersProfiles
                anime={direction === 0 ? true : false}
                users={users}
                msg={msg}
                professionalName={professionalName}
                recProList={recommendProfessionalList}
                openMsg={openMsg}
                closeMsg={closeMsg}
            />
        </div>
    );

    return (
        <div className={style}>
            {IsDevice("desktop") ? (
                contents
            ) : (
                <>
                    <PresentersProfiles
                        anime={direction === 0 ? true : false}
                        users={users}
                        msg={msg}
                        professionalName={professionalName}
                        recProList={recommendProfessionalList}
                        openMsg={openMsg}
                        closeMsg={closeMsg}
                    />
                    <Fab
                        variant="circular"
                        size="small"
                        onClick={() => setOpenFilter(!openFilter)}
                        className={classes.closeButton}
                    >
                        {openFilter ? (
                            <img
                                src={require("../../../assets/image/closeFilter.svg")}
                                alt="tag"
                            />
                        ) : (
                            <FilterListIcon />
                        )}
                    </Fab>
                    <Slide direction="left" in={openFilter}>
                        <div className={styles.presenterFilter}>
                            <PresentersFilters
                                anime={direction === 0 ? true : false}
                                checkedSkills={checkedSkills}
                                checkedTags={checkedTags}
                                changeSkillFilter={changeSkillFilter}
                                changeTagFilter={changeTagFilter}
                            />
                        </div>
                    </Slide>
                </>
            )}
        </div>
    );
}

export default PresentersIndex;
